/** @format */

import {ReactNode, useState} from 'react';

import {BgBox, Content, HoverBox, StyledButton} from './styles';

interface Props {
  content: ReactNode;
  onClick: () => void;
  color: string;
  checked: boolean;
  disabled?: boolean;
}

const SplitButtonSingle = ({content, color, checked, onClick, disabled}: Props) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <StyledButton
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      disabled={disabled}
    >
      <Content>{content}</Content>
      <BgBox customColor={color} checked={checked} />
      <HoverBox isHovered={isHovered} />
    </StyledButton>
  );
};

export {SplitButtonSingle};
